import { http } from "../api";
const easyUnpack = ({ data }) => data;
export const LassieInspectionApi = {
    schedule_inspections: {
        f: function schedule_inspections(turbine_ids, inspection_date, { user_comment = null, inspection_type = null, inspection_method = null, time_zone = null }) {
            let url = '/lassie/inspection/schedule';
            return http.post(url, { turbine_ids, inspection_date, user_comment, inspection_type, inspection_method, time_zone }).then(easyUnpack)
        }
    },
    reject_inspections: {
        f: function reject_inspections(turbine_ids, inspection_ids, { inspection_date = null, user_comment = null }) {
            let url = '/lassie/inspection/reject';
            return http.patch(url, { turbine_ids, inspection_ids, inspection_date, user_comment }).then(easyUnpack)
        }
    },
    resolve_inspections: {
        f: function resolve_inspections(turbine_ids, inspection_ids, inspection_date, { user_comment = null }) {
            let url = '/lassie/inspection/resolve';
            return http.patch(url, { turbine_ids, inspection_ids, inspection_date, user_comment }).then(easyUnpack)
        }
    },
    upload_inspection_data: {
        f: function upload_inspection_data(turbine_id, inspection_id, file_names, file_datas, { target_date = null, user_comment = null }) {
            let url = '/lassie/inspection/inspection-report';
            return http.patch(url, { turbine_id, inspection_id, file_names, file_datas, target_date, user_comment }).then(easyUnpack)
        }
    },
    create_disposition: {
        f: function create_disposition(turbine_id, inspection_id, defect_id, { user_comment = null }) {
            let url = '/lassie/inspection/disposition';
            return http.post(url, { turbine_id, inspection_id, defect_id, user_comment }).then(easyUnpack)
        }
    },
    create_automatic_user_actions: {
        f: function create_automatic_user_actions() {
            let url = '/lassie/inspection/generate-actions';
            return http.post(url, {}).then(easyUnpack)
        }
    },
    list_inspections: {
        f: function list_inspections(turbine_id) {
            let url = '/lassie/inspection/overview';
            return http.get(url, { params: { turbine_id } }).then(easyUnpack)
        }
    },
    update_inspection: {
        f: function update_inspection(inspection_id, windfarm_id, { inspection_date = null, inspection_type = null, inspection_method = null, inspection_status = null, inspection_reason = null }) {
            let url = '/lassie/inspection/$inspection_id'; let parameterNames = ["$inspection_id"];[inspection_id].forEach((parameterValue, index) => { url = url.replace(parameterNames[index], parameterValue) })
            return http.patch(url, { windfarm_id, inspection_date, inspection_type, inspection_method, inspection_status, inspection_reason }).then(easyUnpack)
        }
    },
    list_actions_for_inspection: {
        f: function list_actions_for_inspection(inspection_id) {
            let url = '/lassie/inspection/$inspection_id/actions'; let parameterNames = ["$inspection_id"];[inspection_id].forEach((parameterValue, index) => { url = url.replace(parameterNames[index], parameterValue) })
            return http.get(url, { params: {} }).then(easyUnpack)
        }
    },
    delete_inspection: {
        f: function delete_inspection(inspection_id, windfarm_id) {
            let url = '/lassie/inspection/$inspection_id'; let parameterNames = ["$inspection_id"];[inspection_id].forEach((parameterValue, index) => { url = url.replace(parameterNames[index], parameterValue) })
            return http.delete(url, { data: { windfarm_id } }).then(easyUnpack)
        }
    },
};
